import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from "element-ui";
import directives from '@/utils/preventReClick.js'//防止连点指令v-preventReClick
import "element-ui/lib/theme-chalk/index.css";

Vue.config.silent = true
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(directives) 

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
